import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { VMPaginatedGrid } from '../../components/main/VMPaginatedGrid';
import { Api } from '../../api';
import { getAllChargersColumns } from './AssignedChargers';
import { usePaginatedProvider } from '../../state/paginatedProviderStore';

const UnavailableChargers = observer(() => {
  const UnavailableChargersProvider = usePaginatedProvider(undefined, undefined, false);
  const [sortableFields, setSortableFields] = useState([]);

  useEffect(() => {
    UnavailableChargersProvider.reloadResource();
  }, [UnavailableChargersProvider]);

  const filterCallback = (param?: string, val?: string) => {
    const urlParams: any = {};
    if (param && val) {
      urlParams[param] = val;
    }
    const requestFunction = (offset, sortBy, sortOrder) =>
      Api.charge.listChargersUnavailable({
        ...urlParams,
        skip: offset,
        take: 20,
        sortBy,
        sortOrder,
      });

    UnavailableChargersProvider.setRequest(requestFunction);
    UnavailableChargersProvider.reloadResource();
  };

  useEffect(() => {
    UnavailableChargersProvider.setRequest((offset, sortBy, sortOrder) =>
      Api.charge.listChargersUnavailable({ skip: offset, take: 20, sortBy, sortOrder }),
    );

    UnavailableChargersProvider.setOnFulfilled((_data, _count, sortable) => {
      if (sortable) {
        setSortableFields(sortable);
      }
    });

    UnavailableChargersProvider.reloadResource();
  }, []);
  return (
    <div style={{ width: '100%' }}>
      <VMPaginatedGrid
        rows={UnavailableChargersProvider.data}
        columns={getAllChargersColumns(UnavailableChargersProvider, sortableFields)}
        onPageOffsetChange={UnavailableChargersProvider.onPageChange}
        onSortTypeChange={UnavailableChargersProvider.setSort}
        label="Unavailable Charge Points"
        filterParamOptions={[
          { label: 'OCPP ID', value: 'ocppId' },
          { label: 'Location', value: 'location' },
        ]}
        filterCallback={filterCallback}
        rowHeight={60}
      />
    </div>
  );
});

export default UnavailableChargers;
